import readXlsxFile from 'read-excel-file';
import { getColumnsExcel, formatColumnExcel } from './config';
import { addReac2 } from '../../actions/reacondicionadosActions';

const executeImportExcelReac = async (file, onDone, onProgress) => {
    const rows = await readXlsxFile(file);
    const items = rows.slice(1).map(row => {
        const item = {};
        row.forEach((value, index) => {
            const field = getColumnsExcel[index];
            if (field) item[field] = formatColumnExcel(index)(value);
        });
        return item;
    });

    const total = items.length;
    if (onProgress) onProgress(0, total);

    let added = 0;
    let errors = [];
    let processed = 0;

    for (const item of items) {
        try {
            await addReac2(item);
            added++;
        } catch (err) {
            console.error('Error al importar reacondicionado:', err);
            errors.push(item.modelo || '?');
        }
        processed++;
        if (onProgress) onProgress(processed, total);
    }

    onDone({ added, errors });
};

export default executeImportExcelReac;
